import React, {useEffect, useState} from "react";
import service from './service';
import ProfileScreen from "./ProfileScreen";

const Profiles = () => {

  const [profiles, setProfiles] = useState([]);

  useEffect(() =>
    service.findAllProfiles()
    .then(profiles => setProfiles(profiles)));

  return(
    <ul className="list-group">
      {
        profiles.map(profile =>
          <ProfileScreen profile={profile}/>
        )
      }
    </ul>
  )
};

export default Profiles;
